import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import { withRouter } from "../withRouter";
import {
  authVoterToEvent,
  createVote,
  getCurrentStatement,
  getEventByUrl,
  getEventColors,
  getStatementColors,
  getStatementsCount,
  getVote,
  getVoter,
  getVoterByLink,
  getVoterStatements,
  updateCurrentStatementNumber,
  updateUserStatus,
} from "../api";
import Badge from "react-bootstrap/Badge";
import { QuestionCircleFill } from "react-bootstrap-icons";
import { Toast } from "react-bootstrap";

import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import { withTheme } from "../withTheme";
import bandesPhoviaH from "../assets/bandes_phovia_h.svg";
import VoterNavBar from "./VoterNavBar.js";
import { BASE_URL } from "../config";
import LoadingButton from "./LoadingButton";
import { Spring, animated } from "@react-spring/web";
import Form from "react-bootstrap/Form";

class PresenterSession extends Component {
  constructor(props) {
    super(props);
    this.state = {
      event: null,
      user: null,
      current_statement: null,
      total_statements: 0,
      // Liste ordonnée des assertions servies à CE votant (mode
      // non-présentateur, filtrée par profession côté backend). La
      // navigation se fait par index dans cette liste : les order_number
      // peuvent être troués pour un votant à profession.
      voterStatements: null,
      waiting: true,
      loading: true,
      finished: false,
      showIntroAfterVote: false,
      idVote: null,
      showToast: false,
      comments: "",
      error: false,
      footerHeight: 54,
    };
    this.vh = window.innerHeight * 0.01;
    // Store bound methods as instance properties for proper event listener removal
    this.boundLoadPage = this.loadPage.bind(this);
    this.boundSetVHValue = this.setVHValue.bind(this);
  }

  showAndHideToast = () => {
    this.setState({ showToast: true }, () => {
      setTimeout(() => {
        this.setState({ showToast: false });
      }, 3000);
    });
  };

  generateCircles() {
    const translations = {
      stronglyDisagree:
        this.state.event.langage === "fr"
          ? "Pas du tout d'accord"
          : "Strongly disagree",
      stronglyAgree:
        this.state.event.langage === "fr"
          ? "Tout à fait d'accord"
          : "Strongly agree",
      noOpinion:
        this.state.event.langage === "fr" ? "Sans opinion" : "No opinion",
    };

    return (
      <div
        className="mt-3"
        style={{
          display: "flex",
          flexDirection: "column",
          alignSelf: "center",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignSelf: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          {Array.from({ length: 9 }, (_, index) => (
            <Spring
              key={index}
              borderColor={
                this.state.hoverIndex == index
                  ? this.state.colors?.header_background_color
                  : "transparent"
              }
            >
              {(props) => (
                <animated.div
                  onClick={() => {
                    this.setState({ idVote: index });
                  }}
                  key={index}
                  onMouseEnter={() => {
                    this.setState({ hoverIndex: index });
                  }}
                  onMouseLeave={() => {
                    this.setState({ hoverIndex: null });
                  }}
                  style={{
                    ...props,
                    cursor: "pointer",
                    width: "calc(min(480px, 100vw) / 9 - 8px)",
                    height: "calc(min(480px, 100vw) / 9 - 8px)",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                    fontWeight: this.state.idVote === index ? "bold" : "normal",
                    border: "2px solid",

                    color:
                      index === this.state.idVote
                        ? "var(--light)"
                        : "var(--dark)",
                    backgroundColor:
                      index === this.state.idVote
                        ? this.state.colors?.header_background_color
                        : "var(--light)",
                  }}
                >
                  {index + 1}
                </animated.div>
              )}
            </Spring>
          ))}
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div
            className="fw fs-7"
            style={{ textAlign: "left", width: 100, fontWeight: "bold" }}
          >
            {translations.stronglyDisagree}
          </div>
          <div
            className="fw fs-7"
            style={{ textAlign: "right", width: 100, fontWeight: "bold" }}
          >
            {translations.stronglyAgree}
          </div>
        </div>
        {this.state.event?.with_no_opinion && (
          <div
            onClick={() => {
              this.setState({ idVote: -1 });
            }}
            className="mt-3"
            style={{
              cursor: "pointer",
              height: "calc(min(480px, 100vw) / 9 - 8px)",
              borderRadius: "calc((min(480px, 100vw) / 9 - 8px)/2) ",
              width: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
              fontWeight: this.state.idVote === -1 ? "bold" : "normal",

              color: -1 === this.state.idVote ? "var(--light)" : "var(--dark)",
              backgroundColor:
                -1 === this.state.idVote
                  ? this.state.colors?.header_background_color
                  : "var(--light)",
            }}
          >
            {translations.noOpinion}
          </div>
        )}
      </div>
    );
  }

  // Navigation par index dans la liste des assertions du votant
  // (voterStatements) : remplace getStatementByOrder(order ± 1) qui
  // supposait des order_number contigus.
  indexOfCurrent() {
    const { voterStatements, current_statement } = this.state;
    if (!voterStatements || !current_statement) return -1;
    return voterStatements.findIndex((s) => s.id === current_statement.id);
  }

  nextStatement() {
    const index = this.indexOfCurrent();
    if (index === -1) return null;
    return this.state.voterStatements[index + 1] || null;
  }

  previousStatement() {
    const index = this.indexOfCurrent();
    if (index <= 0) return null;
    return this.state.voterStatements[index - 1];
  }

  // Badge de progression : rang parmi les assertions non-test de la liste
  // du votant. Pour un projet sans professions, identique à
  // display_number/total_statements.
  voterProgress() {
    const { voterStatements, current_statement } = this.state;
    if (!voterStatements || !current_statement) {
      return {
        position: current_statement?.display_number,
        total: this.state.total_statements,
      };
    }
    const nonTest = voterStatements.filter((s) => !s.is_test);
    return {
      position: nonTest.findIndex((s) => s.id === current_statement.id) + 1,
      total: nonTest.length,
    };
  }

  // Fin des assertions du votant : message d'intro en position
  // "after_questionnaire" éventuel, puis suite du parcours (questionnaire de
  // fin ou écran terminé) via proceedAfterVote.
  async handleEndOfStatements() {
    const introPosition =
      this.state.event.intro_message_position || "before_questionnaire";
    if (
      this.state.event.show_first_page &&
      introPosition === "after_questionnaire" &&
      this.state.event.first_message &&
      this.state.user?.event_status !== "finished"
    ) {
      // Revenir aux couleurs du projet pour l'écran d'intro
      await this.loadProjectColors(this.state.event.id);
      this.setState({ showIntroAfterVote: true });
      return;
    }
    await this.proceedAfterVote();
  }

  handleIntroContinue = async () => {
    this.setState({ showIntroAfterVote: false });
    await this.proceedAfterVote();
  };

  // Questionnaire de fin (base ou post-filtre) ou écran terminé. Corps repris
  // tel quel de l'ancienne branche 404 de getStatementByOrder.
  async proceedAfterVote() {
    const baseQuestionnairePlacement = this.state.event.base_questionnaire_placement || "start";

    // If base questionnaire is at end, go to base questionnaire first
    if (
      baseQuestionnairePlacement === "end" &&
      this.state.user?.event_status !== "finished"
    ) {
      this.props.navigate(
        "/events/" + this.props.params.unique_str + "/voter/register",
        {
          state: {
            event_id: this.state.event.id,
            langage: this.state.event.langage,
            form_placement: this.state.event.form_placement,
            base_questionnaire_placement: baseQuestionnairePlacement,
            position: "end",
            unique_str: this.props.params.unique_str,
            post_filter_questionnaire_enabled: this.state.event.post_filter_questionnaire_enabled,
            questionnaire_type: "filter",
          },
        }
      );
      return;
    }

    // If post-filter is at end and enabled, and user hasn't finished yet
    if (
      this.state.event.form_placement == "end" &&
      this.state.event.post_filter_questionnaire_enabled &&
      this.state.user?.event_status !== "finished"
    ) {
      this.props.navigate(
        "/events/" + this.props.params.unique_str + "/voter/register",
        {
          state: {
            event_id: this.state.event.id,
            langage: this.state.event.langage,
            form_placement: this.state.event.form_placement,
            base_questionnaire_placement: baseQuestionnairePlacement,
            position: "end",
            unique_str: this.props.params.unique_str,
            post_filter_questionnaire_enabled: this.state.event.post_filter_questionnaire_enabled,
            questionnaire_type: "post_filter",
          },
        }
      );
      return;
    }
    // Otherwise mark as finished
    await updateUserStatus(this.state.event.id, "finished");
    // Revenir aux couleurs du projet pour la page de fin
    await this.loadProjectColors(this.state.event.id);
    this.setState({ finished: true });
  }

  async handleVote() {
    if (this.state.idVote !== null) {
      try {
        await createVote(this.state.event.id, this.state.current_statement.id, {
          vote_int: this.state.idVote + 1,
          date_of_vote: new Date().toISOString(),
          comments: this.state.comments,
        });
        this.showAndHideToast();
        this.setState({ comments: "" });
        if (!this.state.event.with_presenter) {
          const nextStatement = this.nextStatement();
          if (nextStatement) {
            await updateCurrentStatementNumber(
              this.state.event.id,
              nextStatement.order_number
            );
            let vote = null;
            try {
              vote = await getVote(this.state.event.id, nextStatement.id);
            } catch (e) {
              console.log(e);
            }

            // Charger les couleurs spécifiques à cette nouvelle assertion
            await this.loadStatementColors(
              this.state.event.id,
              nextStatement.id
            );

            this.setState({
              current_statement: nextStatement,
              idVote: vote ? vote.vote_int - 1 : null,
              comments: "",
            });
          } else {
            // Plus d'assertion pour ce votant : fin de vote
            await this.handleEndOfStatements();
          }
        } else this.setState({ waiting: true });
      } catch (e) {}
    }
  }

  async handlePrevious() {
    const prev = this.previousStatement();
    if (!prev) return;

    // Les questions test n'ont pas de vote enregistré : getVote renvoie 404.
    // On récupère le vote précédent s'il existe, sinon on repart sans sélection.
    let vote = null;
    try {
      vote = await getVote(this.state.event.id, prev.id);
    } catch (e) {
      console.log(e);
    }

    // Charger les couleurs spécifiques à cette assertion précédente
    await this.loadStatementColors(this.state.event.id, prev.id);

    this.setState({
      current_statement: prev,
      idVote: vote ? vote.vote_int - 1 : null,
      comments: vote ? vote.comments : "",
    });
  }

  // Nouvelle méthode pour charger les couleurs d'une assertion spécifique
  async loadStatementColors(event_id, statement_id) {
    try {
      const statementColors = await getStatementColors(event_id, statement_id);
      this.setState({ colors: statementColors });
    } catch (error) {
      console.log("Error loading statement colors, using event colors:", error);
      // Fallback sur les couleurs de l'événement si les couleurs de l'assertion échouent
      const eventColors = await getEventColors(event_id);
      this.setState({ colors: eventColors });
    }
  }

  // Méthode pour revenir aux couleurs du projet (utilisée en fin de session)
  async loadProjectColors(event_id) {
    try {
      const eventColors = await getEventColors(event_id);
      this.setState({ colors: eventColors });
    } catch (error) {
      console.log("Error loading project colors:", error);
    }
  }

  async loadPage() {
    try {
      this.setState({ loading: true });
      const event = await getEventByUrl(this.props.params.unique_str);

      // Restore the focus event listener
      if (event.with_presenter)
        window.addEventListener("focus", this.boundLoadPage);

      const colors = await getEventColors(event.id);

      this.setState({ colors });
      if (!event.with_presenter) {
        await authVoterToEvent(event.id);
        const user = await getVoter(event.id);
        this.setState({ user, event, idVote: null, with_presenter: false });

        // Projet à professions : le votant doit avoir choisi la sienne
        // avant de voter (gate → picker, qui revient ici).
        if (!user.profession && user.link) {
          try {
            const voterInfo = await getVoterByLink(event.id, user.link);
            if ((voterInfo.project_professions || []).length > 0) {
              this.props.navigate(
                "/events/" + this.props.params.unique_str + "/voter/profession",
                {
                  state: {
                    unique_str: this.props.params.unique_str,
                    unique_link: user.link,
                    return_to_path:
                      "/events/" +
                      this.props.params.unique_str +
                      "/voter/session",
                    forward_state: {},
                  },
                }
              );
              return;
            }
          } catch (e) {
            console.log(e);
          }
        }

        if (user.event_status === "finished") {
          // User has finished everything (pre-filter, vote, and post-filter if enabled)
          // Revenir aux couleurs du projet pour la page de fin
          await this.loadProjectColors(event.id);
          this.setState({ finished: true, loading: false });
        } else {
          // Liste des assertions de CE votant (filtrée par profession) :
          // position courante = premier statement >= position sauvegardée
          // (si la position pointe sur un statement filtré — re-upload CSV —
          // on avance au prochain applicable), fallback dernier.
          const voterStatements = await getVoterStatements(event.id);
          if (voterStatements.length === 0) {
            await this.loadProjectColors(event.id);
            this.setState({ finished: true, loading: false });
            return;
          }
          const current_statement =
            voterStatements.find(
              (s) => s.order_number >= user.current_statement_number
            ) || voterStatements[voterStatements.length - 1];
          let vote;
          try {
            vote = await getVote(event.id, current_statement.id);
          } catch (e) {
            console.log(e);
          }

          // Charger les couleurs spécifiques à cette assertion
          await this.loadStatementColors(event.id, current_statement.id);

          this.setState({
            voterStatements,
            current_statement,
            comments: vote ? vote.comments : "",
            loading: false,
            waiting: false,
            idVote: vote ? vote.vote_int - 1 : null,
          });
        }
        this.setState({ loading: false });
      } else {
        // Récupérer le nombre total d'assertions (badge présentateur)
        const total_statements = await getStatementsCount(event.id);
        this.setState({ total_statements });

        await authVoterToEvent(event.id);
        const user = await getVoter(event.id);
        this.setState({ user, event, idVote: null });
        // Only create WebSocket if it doesn't exist or is closed.
        // Après getVoter : la socket est identifiée par voter_id, ce qui
        // permet au serveur de dédupliquer les reconnexions (fantômes).
        if (!this.websocket || this.websocket.readyState === WebSocket.CLOSED) {
          this.createWebSocket(event.id, user.id);
        }
        if (event.status === "finished") {
          const baseQuestionnairePlacement = event.base_questionnaire_placement || "start";

          // If base questionnaire is at end and user hasn't finished yet
          if (
            baseQuestionnairePlacement === "end" &&
            user.event_status !== "finished"
          ) {
            this.props.navigate(
              "/events/" + this.props.params.unique_str + "/voter/register",
              {
                state: {
                  event_id: event.id,
                  langage: event.langage,
                  form_placement: event.form_placement,
                  base_questionnaire_placement: baseQuestionnairePlacement,
                  position: "end",
                  unique_str: this.props.params.unique_str,
                  post_filter_questionnaire_enabled: event.post_filter_questionnaire_enabled,
                  questionnaire_type: "filter",
                },
              }
            );
            return;
          }

          // If post-filter is at end and enabled, and user hasn't finished yet
          if (
            event.form_placement == "end" &&
            event.post_filter_questionnaire_enabled &&
            user.event_status !== "finished"
          ) {
            this.props.navigate(
              "/events/" + this.props.params.unique_str + "/voter/register",
              {
                state: {
                  event_id: event.id,
                  langage: event.langage,
                  form_placement: event.form_placement,
                  base_questionnaire_placement: baseQuestionnairePlacement,
                  position: "end",
                  unique_str: this.props.params.unique_str,
                  post_filter_questionnaire_enabled: event.post_filter_questionnaire_enabled,
                  questionnaire_type: "post_filter",
                },
              }
            );
            return;
          }
          // Revenir aux couleurs du projet pour la page de fin
          await this.loadProjectColors(event.id);
          this.setState({ finished: true, loading: false });
          return;
        }
        if (event.status === "to come" || event.pause) {
          this.setState({ waiting: true });
        } else {
          const current_statement = await getCurrentStatement(event.id);
          try {
            await getVote(event.id, current_statement.id);
          } catch (e) {
            this.setState({ waiting: false });
          }

          // Charger les couleurs spécifiques à cette assertion
          await this.loadStatementColors(event.id, current_statement.id);

          this.setState({ current_statement });
        }
        this.setState({ loading: false });
      }
    } catch (e) {
      let error_message;

      // Checking if the response is available from the server
      if (e.response) {
        // Handle specific status codes
        switch (e.response.status) {
          case 400:
            this.props.navigate(
              "/events/" + this.props.params.unique_str + "/voter"
            );
            return; // exit from the function
          case 401:
            // Handle 401 Unauthorized response from the server
            this.props.navigate(
              "/events/" + this.props.params.unique_str + "/voter"
            );
            return;
          case 404:
            this.props.navigate(
              "/events/" + this.props.params.unique_str + "/voter"
            );
          default:
            // Display the error detail from the server
            error_message =
              e.response.data.detail || "An unexpected error occurred.";
            break;
        }
      } else {
        console.log(e);
        // Handle the scenario where there's no response (likely a network/connection error)
        error_message = "A connection error occurred. Please try again later.";
      }

      // Set the state to reflect the error
      this.setState({ error: true, error_message, loading: false });
    }
  }
  setVHValue = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  async componentDidMount() {
    // Replace this URL with the correct endpoint URL
    this.setVHValue();
    window.addEventListener("resize", this.boundSetVHValue);

    this.loadPage();
  }

  createWebSocket(event_id, voter_id) {
    // Close any existing websocket before creating a new one
    if (this.websocket) {
      // Only attempt to close if the connection is not already closed
      if (this.websocket.readyState !== WebSocket.CLOSED) {
        this.websocket.close();
      }
      // Remove the reference to the old websocket
      this.websocket = null;
    }

    const connect = () => {
      // Don't reconnect if component is unmounting
      if (this.isUnmounting) {
        return;
      }

      const cleanBaseURL = BASE_URL.replace(/^https?:\/\//, "");
      this.websocket = new WebSocket(
        `wss://${cleanBaseURL}/ws/event/${event_id}` +
          (voter_id ? `?voter_id=${voter_id}` : "")
      );

      this.websocket.onopen = () => {
        console.log("WebSocket connection opened");
        // Reset reconnection attempts on successful connection
        this.reconnectAttempts = 0;
      };

      this.websocket.onmessage = (event) => {
        const message = JSON.parse(event.data);
        switch (message.action) {
          // Handle different actions here
          case "launch_event":
            this.setState({ waiting: false });
            this.fetchNewStatement();
            break;
          case "finish_voting":
            this.setState({ waiting: true });
            break;
          case "pause_event":
            this.setState({ waiting: true });
            break;
          case "next_statement":
            this.setState({ waiting: false });
            this.fetchNewStatement();
            break;
          case "finish_event":
            const baseQuestionnairePlacementWs = this.state.event.base_questionnaire_placement || "start";

            // If base questionnaire is at end, navigate to base questionnaire first
            if (baseQuestionnairePlacementWs === "end") {
              this.props.navigate(
                "/events/" + this.props.params.unique_str + "/voter/register",
                {
                  state: {
                    event_id: this.state.event.id,
                    langage: this.state.event.langage,
                    form_placement: this.state.event.form_placement,
                    base_questionnaire_placement: baseQuestionnairePlacementWs,
                    position: "end",
                    unique_str: this.props.params.unique_str,
                    post_filter_questionnaire_enabled: this.state.event.post_filter_questionnaire_enabled,
                    questionnaire_type: "filter",
                  },
                }
              );
            } else if (
              this.state.event.form_placement == "end" &&
              this.state.event.post_filter_questionnaire_enabled
            ) {
              // If post-filter is at end and enabled, navigate to post-filter
              this.props.navigate(
                "/events/" + this.props.params.unique_str + "/voter/register",
                {
                  state: {
                    event_id: this.state.event.id,
                    langage: this.state.event.langage,
                    form_placement: this.state.event.form_placement,
                    base_questionnaire_placement: baseQuestionnairePlacementWs,
                    position: "end",
                    unique_str: this.props.params.unique_str,
                    post_filter_questionnaire_enabled: this.state.event.post_filter_questionnaire_enabled,
                    questionnaire_type: "post_filter",
                  },
                }
              );
            } else {
              // Revenir aux couleurs du projet pour la page de fin
              this.loadProjectColors(this.state.event.id);
              this.setState({ finished: true });
            }
            break;
          case "reset_event":
            // L'event a été réinitialisé par l'admin : le votant a été
            // supprimé en base, retour à la page d'inscription.
            this.props.navigate(
              "/events/" + this.props.params.unique_str + "/voter"
            );
            break;
          default:
            console.log("Unknown action:", message.action);
        }
      };

      this.websocket.onclose = (event) => {
        console.log("WebSocket connection closed", event.code);

        // If the connection was not closed cleanly and component is not unmounting
        if (event.code !== 1000 && !this.isUnmounting) {
          // Implement exponential backoff for reconnection
          this.reconnectAttempts = (this.reconnectAttempts || 0) + 1;
          const delay = Math.min(
            5000 * Math.pow(1.5, this.reconnectAttempts - 1),
            30000
          );

          console.log(
            `Reconnecting in ${delay / 1000} seconds... (attempt ${
              this.reconnectAttempts
            })`
          );
          this.reconnectTimeout = setTimeout(connect, delay);
        }
      };

      this.websocket.onerror = (error) => {
        console.error("WebSocket Error:", error);
        // Don't close the connection here, let the onclose handler handle reconnection
      };
    };

    connect(); // Initiating the connection
  }

  componentWillUnmount() {
    // Set flag to prevent reconnection attempts
    this.isUnmounting = true;

    // Clear any pending reconnect timeout
    if (this.reconnectTimeout) {
      clearTimeout(this.reconnectTimeout);
    }

    // Remove focus event listener
    window.removeEventListener("focus", this.boundLoadPage);
    window.removeEventListener("resize", this.boundSetVHValue);

    // Close the WebSocket connection when the component is unmounted
    if (this.websocket) {
      this.websocket.close();
      this.websocket = null;
    }
  }

  formatStatement(statement) {
    // Accepter directement le HTML pour plus de flexibilité
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: statement,
        }}
      />
    );
  }

  async fetchNewStatement() {
    try {
      this.setState({ loading: true, idVote: null });
      const current_statement = await getCurrentStatement(this.state.event.id);

      // Charger les couleurs spécifiques à cette nouvelle assertion
      await this.loadStatementColors(this.state.event.id, current_statement.id);

      this.setState({ current_statement, loading: false });
    } catch (e) {}
  }

  renderPage() {
    const translations = {
      endOfVote:
        this.state.event?.project_id == 10 || this.state.event?.project_id == 16
          ? this.state.event?.langage === "fr"
            ? "Nous vous remercions grandement d'avoir pris le temps de remplir ce questionnaire. <br/><br/> Vos votes et commentaires seront très utiles pour améliorer les recommandations établies dans le cadre de ce consensus Delphi.<br/><br/>Pour rappel, ces recommandations feront l'objet, par la suite, d'une publication dans une revue scientifique à Comité de Lecture.<br/><br/>Le Comité Scientifique et de Pilotage*.<br/><br/>*Prs / Drs Marie-Noelle DELYFER, Bénédicte DUPAS, Jean-François GIRMENS, Michel PAQUES et Stéphanie BAILLIF, Mohamed BENNANI, Corinne DOT, Vincent GUALINO et Pascale MASSIN."
            : "We thank you very much for taking the time to fill out this questionnaire. <br/><br/> Your votes and comments will be very useful to improve the recommendations established as part of this Delphi consensus.<br/><br/>As a reminder, these recommendations will subsequently be published in a scientific journal with Peer Review. <br/><br/>The Scientific and Steering Committee*.<br/><br/>*Prs / Drs Marie-Noelle DELYFER, Bénédicte DUPAS, Jean-François GIRMENS, Michel PAQUES et Stéphanie BAILLIF, Mohamed BENNANI, Corinne DOT, Vincent GUALINO et Pascale MASSIN."
          : this.state.event?.project_id == 17
          ? this.state.event?.langage === "fr"
            ? "Nous vous remercions grandement d'avoir pris le temps de remplir ce questionnaire. <br/><br/> Vos votes seront très utiles pour améliorer les recommandations établies dans le cadre de ce consensus Delphi. <br/><br/>Pour rappel, ces recommandations feront l'objet, par la suite, d'une publication dans une revue scientifique à Comité de Lecture.<br/><br/>*Dr Sylvie ROYANT-PAROLA, Dr Marjorie GUILLET,  <br/>Pr Yves DAUVILLIERS, Pr Pierre-Alexis GEOFFROY, <br/>Pr Damien LÉGER, Dr Jean-Bastien MICOULAUD et <br/>Pr Jean-Louis PÉPIN."
            : "We thank you very much for taking the time to fill out this questionnaire. <br/><br/> Your votes will be very useful to improve the recommendations established as part of this Delphi consensus.<br/><br/>As a reminder, these recommendations will subsequently be published in a scientific journal with Peer Review.<br/><br/>*Dr Sylvie ROYANT-PAROLA, Dr Marjorie GUILLET,  <br/>Pr Yves DAUVILLIERS, Pr Pierre-Alexis GEOFFROY, <br/>Pr Damien LÉGER, Dr Jean-Bastien MICOULAUD et <br/>Pr Jean-Louis PÉPIN."
          : this.state.event?.langage === "fr"
          ? "Nous vous remercions grandement d'avoir pris le temps de remplir ce questionnaire. <br/><br/> Vos votes et commentaires seront très utiles pour améliorer les recommandations établies dans le cadre de ce consensus Delphi.<br/><br/>Pour rappel, ces recommandations feront l'objet, par la suite, d'une publication dans une revue scientifique à Comité de Lecture.<br/><br/>Medical Education Corpus au nom du comité de Pilotage*.<br/><br/>*Dr Sylvie ROYANT-PAROLA, Dr Marjorie GUILLET,  <br/>Pr Yves DAUVILLIERS, Pr Pierre-Alexis GEOFFROY, <br/>Pr Damien LÉGER, Dr Jean-Bastien MICOULAUD et <br/>Pr Jean-Louis PÉPIN."
          : "We thank you very much for taking the time to fill out this questionnaire. <br/><br/> Your votes and comments will be very useful to improve the recommendations established as part of this Delphi consensus.<br/><br/>As a reminder, these recommendations will subsequently be published in a scientific journal with Peer Review. <br/><br/>Medical Education Corpus on behalf of the Steering Committee*.<br/><br/>*Dr Sylvie ROYANT-PAROLA, Dr Marjorie GUILLET, <br/>Pr Yves DAUVILLIERS, Pr Pierre-Alexis GEOFFROY, <br/>Pr Damien LÉGER, Dr Jean-Bastien MICOULAUD et <br/>Pr Jean-Louis PÉPIN.",

      contact: this.state.event?.event_contact_message
        ? this.state.event.event_contact_message +
          (this.state.event.event_end_contact
            ? " " + this.state.event.event_end_contact
            : "")
        : this.state.event?.langage === "fr"
        ? "Pour toute demande d'information, merci d'envoyer un email à " +
          this.state.event?.event_end_contact
        : "For any information request, please send an email to " +
          this.state.event?.event_end_contact,

      thanksForParticipation:
        this.state.event?.langage === "fr"
          ? "MERCI POUR VOTRE PARTICIPATION"
          : "THANKS FOR YOUR PARTICIPATION",
      pleaseWait:
        this.state.event?.langage === "fr"
          ? "Veuillez attendre le prochain vote..."
          : "Please wait for the next vote...",
      statementToVote:
        this.state.event?.langage === "fr" ? "Assertion" : "Statement to vote",
      example: this.state.event?.langage === "fr" ? "Exemple" : "Example",
      howMuchAgree:
        this.state.event?.langage === "fr"
          ? "Que pensez-vous de cette assertion ?"
          : "How much do you agree with this statement ?",
      vote: this.state.event?.langage === "fr" ? "Voter" : "Vote",
      previous: this.state.event?.langage === "fr" ? "Précédent" : "Previous",
      comments:
        this.state.event?.langage === "fr" ? "Commentaires" : "Comments",
      commentsPlaceholder:
        this.state.event?.langage === "fr"
          ? "Entrez vos commentaires ici"
          : "Enter your comments here",

      infoDelphi:
        this.state.event?.langage === "fr"
          ? "Vous avez la possibilité de quitter le vote en cours à tout moment et de poursuivre votre session plus tard en cliquant sur le lien d'accès que vous avez reçu."
          : "You can leave the vote in progress at any time and resume your session later by clicking on the access link you received.",

      saveAndQuit:
        this.state.event?.langage === "fr"
          ? "Enregistrer et quitter"
          : "Save and quit",
    };

    // Intro "after_questionnaire" : affichée après la dernière assertion,
    // avant le questionnaire de fin éventuel. Même design que VoterIntro.
    if (this.state.showIntroAfterVote) {
      return (
        <>
          <div
            className="p-3 mb-4"
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "15px",
              backgroundColor: this.state.colors?.statement_background_color,
            }}
          >
            <span
              className="text-light"
              style={{
                fontSize: "1.5em",
              }}
              dangerouslySetInnerHTML={{
                __html: this.state.event.first_message,
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <LoadingButton
              variant="dark"
              size="lg"
              onClick={this.handleIntroContinue}
            >
              {this.state.event.langage === "fr" ? "Continuer" : "Continue"}
            </LoadingButton>
          </div>
        </>
      );
    }

    if (this.state.finished) {
      return (
        <>
          <div
            className="p-3"
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "15px",
              backgroundColor: this.state.colors?.statement_background_color,
            }}
          >
            {this.state.event.event_end_message && (
              <span
                className="text-light fw-bold "
                style={{
                  fontSize: "1.5em",
                }}
                dangerouslySetInnerHTML={{
                  __html: this.state.event.event_end_message,
                }}
              ></span>
            )}
            {/* <span className="text-light fw-bold">
            {translations.thanksForParticipation}
          </span> */}
          </div>
          {this.state.event.event_end_contact && (
            <p className="mt-2">{translations.contact}</p>
          )}
        </>
      );
    } else if (this.state.loading)
      return (
        <div
          className="p-3"
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      );
    else if (this.state.waiting) {
      return (
        <div
          style={{
            display: "flex",
            flexGrow: 1,
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
          }}
        >
          <div
            className="p-4"
            style={{
              display: "flex",
              width: "100%",
              maxWidth: "320px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "15px",
              backgroundColor: this.state.colors?.header_background_color,
            }}
          >
            <span className="text-light pb-3">{translations.pleaseWait}</span>
            <Spinner animation="border" variant="light" />
          </div>
        </div>
      );
    } else {
      return (
        <>
          <div
            className="pb-3"
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                flex: 1,
                width: "100%",
                height: "100%",
                borderRadius: "10px",
                flexDirection: "column",
              }}
            >
              {this.state.current_statement.session_subtitle && (
                <div className="mb-2">
                  <h4>
                    <b>{this.state.current_statement.session_subtitle}</b>
                  </h4>
                </div>
              )}
              <div
                className="mb-2"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <h4 style={{ padding: 0, margin: 0 }}>
                  {translations.statementToVote}
                </h4>
                <div
                  style={{
                    display: "flex",
                    minWidth: "3.5em",
                    height: "2.5em",
                    borderRadius: "1.25em",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  className="bg-light ms-2"
                >
                  <span className="fw-bolder">
                    {this.state.current_statement.is_test
                      ? translations.example
                      : this.state.event?.with_presenter
                      ? `${this.state.current_statement.display_number}/${this.state.total_statements}`
                      : `${this.voterProgress().position}/${this.voterProgress().total}`}
                  </span>
                </div>
              </div>
              <Spring
                key={this.state.current_statement?.id}
                from={{ opacity: 0, transform: "scale(0.8)" }}
                to={{ opacity: 1, transform: "scale(1)" }}
              >
                {(props) => (
                  <animated.div
                    style={{
                      ...props,
                      display: "flex",
                      borderRadius: "15px",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                      backgroundColor:
                        this.state.colors?.statement_background_color,
                      boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                    }}
                    className="p-3 mb-4"
                  >
                    <span className="fs-4 fw-semibold text-light">
                      {this.formatStatement(
                        this.state.current_statement.statement_string
                      )}
                    </span>
                  </animated.div>
                )}
              </Spring>
              {this.state.current_statement.image_url && (
                <div className="mb-3">
                  <img
                    style={{ width: "100%" }}
                    src={this.state.current_statement.image_url}
                  ></img>
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  justifyContent: "space-around",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <QuestionCircleFill
                    className="me-2"
                    size={24}
                  ></QuestionCircleFill>
                  <span className="fs-6 fw-bolder">
                    {translations.howMuchAgree}
                  </span>
                </div>
                {this.generateCircles()}
                {this.state.event?.with_comments && (
                  <div
                    className="mt-3"
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      flex: 1,
                    }}
                  >
                    <Form.Group controlId="formBasicComment" className="w-100">
                      <Form.Label>{translations.comments}</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder={translations.commentsPlaceholder}
                        value={this.state.comments}
                        onChange={(e) =>
                          this.setState({ comments: e.target.value })
                        }
                      />
                    </Form.Group>
                  </div>
                )}

                <div
                  className="mt-3"
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    flex: 1,
                  }}
                >
                  {!this.state.event?.with_presenter &&
                    this.previousStatement() && (
                      <LoadingButton
                        variant="dark"
                        size="lg"
                        className="me-3"
                        onClick={this.handlePrevious.bind(this)}
                      >
                        {translations.previous}
                      </LoadingButton>
                    )}

                  <LoadingButton
                    variant="dark"
                    size="lg"
                    onClick={this.handleVote.bind(this)}
                    disabled={this.state.idVote === null}
                  >
                    {translations.vote}
                  </LoadingButton>
                </div>
                {!this.state.event?.with_presenter && (
                  <div
                    className="mt-2"
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      flex: 1,
                    }}
                  >
                    <LoadingButton
                      variant="light"
                      size="sm"
                      onClick={() => {
                        this.props.navigate(
                          "/events/" +
                            this.props.params.unique_str +
                            "/voter/" +
                            this.state.user.link
                        );
                      }}
                    >
                      {translations.saveAndQuit}
                    </LoadingButton>
                  </div>
                )}
              </div>
            </div>
            {this.state.event && this.state.event.legal_notice && (
              <div
                className="text-center mb-2"
                style={{
                  fontSize: "0.8rem",
                  color: this.state.colors?.text_color || "#666",
                }}
              >
                {this.state.event.legal_notice}
              </div>
            )}
          </div>
        </>
      );
    }
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "calc(var(--vh, 1vh) * 100)",
          position: "relative",
          paddingBottom: this.state.footerHeight + "px",

          backgroundColor: this.state.colors?.background_color,
          overflowX: "hidden",
        }}
      >
        {this.state.event && (
          <img
            src={
              this.state.event
                ? BASE_URL +
                  "/events/" +
                  this.state.event.id +
                  "/data/voter_footer"
                : null
            }
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              objectFit: "contain",
            }}
            onLoad={(e) => {
              const h = e.target.getBoundingClientRect().height;
              if (h && Math.round(h) !== this.state.footerHeight) {
                this.setState({ footerHeight: Math.round(h) });
              }
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = "none";
            }}
          />
        )}
        {this.state.event && (
          <VoterNavBar
            text={
              !this.state.finished && !this.state.showIntroAfterVote
                ? this.state.current_statement?.session_name ||
                  this.state.event.event_title
                : this.state.event.event_title
            }
            backgroundColor={this.state.colors?.header_background_color}
          ></VoterNavBar>
        )}

        <Container
          style={{ maxWidth: "800px" }}
          fluid
          className="px-3 pt-3 flex-grow-1 d-flex flex-column"
        >
          {this.state.event?.with_presenter && (
            <Toast show={this.state.showToast}>
              <Toast.Header>
                <strong className="me-auto">Thank you</strong>
              </Toast.Header>
              <Toast.Body>Your reply has been sent!</Toast.Body>
            </Toast>
          )}

          <Alert show={this.state.error} variant={"danger"}>
            <Alert.Heading>Error</Alert.Heading>
            <p>{"An error occured : " + this.state.error_message}</p>
            <hr />
          </Alert>
          {!this.state.loading &&
            this.state.user &&
            this.state.user.username && (
              <div className="mb-4">
                <span className="fs-6">
                  {this.state.event?.langage === "fr" ? "Pseudo" : "Username"}:{" "}
                </span>
                <Badge bg="dark">{this.state.user.username}</Badge>
              </div>
            )}
          {this.renderPage()}
        </Container>
      </div>
    );
  }
}

export default withRouter(withTheme(PresenterSession));
